// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@5.2.5_webpack@4.47.0_webpack-cli@4.10.0_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-answer-card-correction-default p{font-size:16px;color:#333;text-align:center}.plv-iar-answer-card-correction-default p span{color:#45acff;font-size:18px;font-weight:600}.plv-iar-answer-card-correction-default__text{font-size:16px;color:#333;text-align:center;font-weight:bold}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
